import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { isSandbox } from "@faire/web--source/common/sandbox";
export var replaceSubdomainInSandboxInterceptor = function(config) {
    var _getWindow_location, _getWindow;
    var _getWindow_location_href;
    // E2E sandbox doesn't support subdomains, so we need to replace it with www
    // when targeting sandbox environment as BE
    if (isSandbox((_getWindow_location_href = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href) !== null && _getWindow_location_href !== void 0 ? _getWindow_location_href : "") && config.subdomain === "events.api") {
        config.subdomain = "www";
    }
    return config;
};
